// Node の Buffer 最小互換（ブラウザ完結版用・esbuild inject でグローバル供給）。
// 用途は共有 lib の base64/バイナリ処理（画像保存・Meshy data URI 等）に限定し、
// 必要なメソッドだけを Uint8Array 拡張で提供する。
/* eslint-disable no-bitwise */
class VnBuffer extends Uint8Array {
    static isBuffer(x) { return x instanceof Uint8Array; }

    static from(input, encoding) {
        if (typeof input === 'string') {
            if (encoding === 'base64') {
                const bin = atob(input.replace(/\s+/g, ''));
                const out = new VnBuffer(bin.length);
                for (let i = 0; i < bin.length; i++) out[i] = bin.charCodeAt(i);
                return out;
            }
            // 既定は utf8
            return new VnBuffer(new TextEncoder().encode(input));
        }
        if (input instanceof ArrayBuffer) return new VnBuffer(new Uint8Array(input));
        if (ArrayBuffer.isView(input)) {
            // Buffer.from(view.buffer, byteOffset, length) 互換は第2/3引数で対応
            if (typeof encoding === 'number') {
                const length = arguments.length >= 3 ? arguments[2] : undefined;
                return new VnBuffer(new Uint8Array(input.buffer ?? input, encoding, length));
            }
            return new VnBuffer(new Uint8Array(input.buffer, input.byteOffset, input.byteLength));
        }
        if (Array.isArray(input)) return new VnBuffer(Uint8Array.from(input));
        throw new TypeError('VnBuffer.from: 未対応の入力型です');
    }

    static concat(list, totalLength) {
        const total = totalLength ?? list.reduce((n, b) => n + b.length, 0);
        const out = new VnBuffer(total);
        let off = 0;
        for (const b of list) { out.set(b, off); off += b.length; }
        return out;
    }

    static byteLength(str, encoding) {
        return VnBuffer.from(String(str), encoding).length;
    }

    toString(encoding = 'utf8') {
        if (encoding === 'base64') {
            let bin = '';
            for (let i = 0; i < this.length; i += 0x8000) {
                bin += String.fromCharCode(...this.subarray(i, i + 0x8000));
            }
            return btoa(bin);
        }
        return new TextDecoder().decode(this);
    }
}

export { VnBuffer as Buffer };
